import styled from 'styled-components';
export const Cbtn = styled.button` 
    border: 2px solid #301C86;
    cursor: pointer;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    padding: 0 20px;
    background-color: white;
    transition: 0.5s;
    color: #301C86;
`
export const name = styled.p`
    font-weight: 700;
    font-size: 16px;

`